import React from 'react';

function Overlay(props) {
	let v = "visible";
	if(props.cHeight === "0%") {
		v = "hidden";
	}
	// return (<div className="overlay" id="overlay" style={{top: props.top, left: props.left}}>
	return (<div className="overlay" id="overlay" >
		<div className="overlay-content" id="overlay-content" style={{visibility: v}}>
			{props.content}
		</div>
	</div>);
}

export default Overlay;
